import {IWuAppHeaderAccount} from '@/components/appHeader/types/WuAppHeaderAccount'
import {cn} from '@/lib/utils'

export const OtherMenuItem: React.FC<{
  user: IWuAppHeaderAccount
  dir?: 'ltr' | 'rtl'
}> = ({user, dir}) => {
  const otherList = [
    user?.usage
      ? {
          title: user.usage.title,
          url: user.usage.url,
          icon: 'wm-bar-chart text-base',
          node: (
            <div className="flex flex-col items-center w-20">
              <code className="font-medium">
                {user.usage.collectedResponseCount || '0'}
              </code>
              <span className="text-xs font-normal">Responses</span>
            </div>
          ),
        }
      : null,
    user?.invoice
      ? {
          title: user.invoice.title,
          url: user.invoice.url,
          icon: 'wm-attach-money text-base font-semibold',
          node: (
            <div className="flex flex-col items-center w-20">
              <code>{user.invoice.size}</code>
            </div>
          ),
        }
      : null,
  ].filter(Boolean) as {
    title: string
    url: string
    icon: string
    node: React.JSX.Element
  }[]

  return (
    <>
      <ul>
        {otherList.map(({title, url, icon, node}, i) => (
          <li
            key={i}
            className={
              i < otherList.length - 1 ? 'border-b border-gray-subtle' : ''
            }
          >
            <a
              href={url}
              className={cn(
                'flex items-center justify-between py-2 hover:bg-gray-20 focus-within:bg-gray-20 focus:outline-none',
                dir === 'rtl' ? 'pl-4' : 'pr-4',
              )}
            >
              <div className="flex items-center gap-2">
                <span className={cn(icon, 'w-12 text-center')}></span>
                <span>{title}</span>
              </div>
              {node}
            </a>
          </li>
        ))}
      </ul>
      <hr className="border-gray-subtle" />
    </>
  )
}
